import React, { useEffect, useState } from 'react';
import Input from 'antd/es/input/Input';
import moment from 'moment';
import { DAY_FORMAT } from '../../../constants';
import BaseTable from '../Base';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
const RouteAddRidersTable = ({ dataSource, isFetching, pagination, ...props }) => {
  const [searchedRiders, setSearchedRiders] = useState(dataSource || []);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchedRiders(dataSource);
  }, [dataSource]);

  useEffect(() => {
    let riderT = dataSource;
    if (!isEmpty(searchValue)) {
      riderT = filter(dataSource, (rider) => {
        return (
          rider.user.email?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          rider?.user.name?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          rider.phone?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          rider.startAddress?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          rider.endAddress?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          rider.shiftStart?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          rider.shiftEnd?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          rider.status?.toString().toLowerCase().match(searchValue.toLowerCase())
        );
      });
    }
    setSearchedRiders(riderT);
  }, [searchValue]);

  const handleOnSearch = (e) => {
    setSearchValue(e.target.value);
  };
  const columns = [
    {
      title: 'Rider ID',
      dataIndex: 'riderId',
      key: 'riderId',
      fixed: 'left',
      width: 150,
    },
    {
      title: 'Rider Name',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (value, row) => {
        return row.user.name;
      },
    },
    {
      title: 'Rider Type',
      dataIndex: 'riderType',
      key: 'riderType',
      width: 120,
      render: (value) => {
        return <div className={value}> {value}</div>;
      },
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (value, row) => {
        return row.user.email;
      },
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'Time Shift',
      dataIndex: 'name',
      key: 7,
      render: (value, row) => {
        return row.timeStart + ' - ' + row.timeEnd;
      },
    },
    {
      title: 'Created Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value, row) => {
        return moment(row.user.createdAt).format(DAY_FORMAT);
      },
    },
    {
      title: 'Updated Date',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (value, row) => {
        return moment(row.user.updatedAt).format(DAY_FORMAT);
      },
    },
    {
      title: 'Status',
      key: 'status',
      fixed: 'right',
      width: 150,
      render() {
        return <span className={'routePlanRiderStatus ' + 'Unassigned'}>Unassigned</span>;
      },
    },
  ];

  return (
    <div className="RoutePlanAddRiders table-common">
      <div className="riders-header table-header">
        <div className="search">
          <Input
            onChange={handleOnSearch}
            placeholder="Search"
            suffix={<img src="/icons/search.svg" />}
            disabled={isFetching}
            value={searchValue}
          />
        </div>
      </div>
      <BaseTable
        columns={columns}
        pagination={pagination}
        scroll={{ x: 2200 }}
        dataSource={searchedRiders}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-dark' : 'table-row-light')}
        {...props}
      />
    </div>
  );
};

export default RouteAddRidersTable;
